import { PropsWithChildren, ReactNode } from 'react';
import { Container, Ellipticable, Stack, StackProps, Typography, TypographyOptions } from '@optimus-web/core';

interface LabeledListItemProps {
    label?: ReactNode;
    itemAlignment?: StackProps['itemAlignment'];
    vertical?: StackProps['vertical'];
    labelOptions?: Pick<TypographyOptions, 'whiteSpace'>;
    contentOptions?: Pick<TypographyOptions, 'overflowWrap' | 'wordBreak' | 'whiteSpace'> & Ellipticable;
}

export const LabeledListItem = ({
    label,
    children,
    itemAlignment = 'end',
    vertical,
    labelOptions,
    contentOptions,
    ...props
}: PropsWithChildren<LabeledListItemProps>) => (
    <Container padding={['200', '0']} {...props}>
        <Stack spacing="150" itemAlignment={itemAlignment} vertical={vertical}>
            {label ? (
                <Typography textStyle="bodyLarge" variant="secondary" {...labelOptions} as="div">
                    {label}
                </Typography>
            ) : null}
            <Typography textStyle="bodyLarge" {...contentOptions} as="div">
                {children}
            </Typography>
        </Stack>
    </Container>
);
